import React from 'react';
import { Map, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import MarkerCluster from './MarkersCluster';
import { connect } from 'react-redux';
import { UserAction } from 'redux/actions';
import {
    Card,CardBody
} from 'reactstrap';

const MapComp = (props) => {

    let [center] = React.useState({
        lat: 36.778259,
        lng: -119.417931
    });
    const ZOOM_LEVEL = 6;
    const mapRef = React.useRef();
    let [openPopup, setOpenPopup] = React.useState({});
    //let [mapBoundryCenter, setMapBoundryCenter] = React.useState(center);


    /*const calulateDistance = (lat1, lon1, lat2, lon2, unit) => {

        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1-lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit=="K") { dist = dist * 1.609344 }
            if (unit=="N") { dist = dist * 0.8684 }
            return dist;
        }
    }*/


    const onViewportChanged = (e) => {
        let mapInst = mapRef.current.leafletElement;
        /*const mapCenter = e.center;
        const distance = calulateDistance(mapCenter[0],mapCenter[1], mapBoundryCenter.lat, mapBoundryCenter.lng,'KM');
        if(distance >= 10){
            setMapBoundryCenter({
                lat: mapCenter[0],
                lng: mapCenter[1]
            });
            fetchLatLong(mapInst);
        }*/
        fetchLatLong(mapInst);
    }

    const fetchLatLong = (map) => {

        if (map) {
            const bounds = map.getBounds();
            const ne = bounds._northEast;
            const sw = bounds._southWest;
            const boundry = { a: sw.lat, b: sw.lng, c: ne.lat, d: ne.lng }
            props.getUsersLocations(boundry);
        }
    }

    return (
        <div>
            <Card style={{width:'100%'}}>
                <CardBody>
                    <Map
                        onPopupClose={(e) => setOpenPopup({})}
                        onPopupOpen={(e) => setOpenPopup(e.popup._latlng)}
                        closePopupOnClick={false}
                        minZoom={5}
                        whenReady={() => {
                            fetchLatLong(mapRef.current.leafletElement)
                        }}
                        whenCreated={(map) => {
                        }}
                        onViewportChanged={onViewportChanged} ref={mapRef}
                        center={center}
                        zoom={ZOOM_LEVEL}
                        scrollWheelZoom={true}
                        style={{ border: '1px solid', borderRadius: '5px', height: (props.height) ? props.height : 600, width: (props.width) ? props.width : '100%' }}>
                        <TileLayer
                            noWrap={true}
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <MarkerCluster markers={props.users} popup={openPopup} />
                    </Map>
                </CardBody>
            </Card>
        </div>
    );
}

const mapStateToProps = (state) => ({
    users: (state.user && state.user.usersLocations && state.user.usersLocations.users) ? state.user.usersLocations.users : [],
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    getUsersLocations: (payload) => dispatch(UserAction.getUsersLocations(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapComp);

